import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-status-drop-down',
  templateUrl: './status-drop-down.component.html',
  styleUrls: ['./status-drop-down.component.css']
})
export class StatusDropDownComponent {

  @Input() inputList: any = [];
  @Input() currentStatus: string = '';
  @Output() statusSelected: EventEmitter<any> = new EventEmitter<any>;
  @Input() productId: string = '';
  @Input() type: string = '';
  selectedStatus: string = '';

  getStatus() {

    this.statusSelected.emit({ selectedStatusId: this.currentStatus, type: this.type, productId: this.productId });

  }

}
